module.exports = __webpack_public_path__ + "img/depmap_svg_V157.d864a568.svg";